import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconFormatText(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.14949 16.55C6.36615 16.85 6.69948 17 7.14948 17C7.36615 17 7.57048 16.9333 7.76248 16.8C7.95382 16.6667 8.08282 16.5083 8.14948 16.325L9.19948 13.4H14.8495L15.8495 16.325C15.9162 16.5083 16.0455 16.6667 16.2375 16.8C16.4288 16.9333 16.6245 17 16.8245 17C17.2912 17 17.6328 16.85 17.8495 16.55C18.0662 16.25 18.0912 15.8833 17.9245 15.45L13.6745 4.15C13.5578 3.83333 13.3368 3.56233 13.0115 3.337C12.6868 3.11233 12.3578 3 12.0245 3C11.6745 3 11.3328 3.11233 10.9995 3.337C10.6662 3.56233 10.4412 3.83333 10.3245 4.15L6.07448 15.45C5.90782 15.8833 5.93282 16.25 6.14949 16.55ZM14.0995 11.4H9.89948L11.9495 5.6H12.0495L14.0995 11.4Z"
        fill="currentColor"
      />
      <path
        d="M5.99997 20H18C18.5523 20 19 19.5523 19 19C19 18.4477 18.5523 18 18 18H5.99997C5.44769 18 4.99997 18.4477 4.99997 19C4.99997 19.5523 5.44769 20 5.99997 20Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
